<template>
  <div class="paging">
    <ul class="pagination" :class="{ 'justify-content-center': pages.options.centered }">
      <li v-if="pages.options.current !== 1" class="page-item">
        <a class="page-link" @click="$emit('change', pages.options.current - 1)" v-html="pages.options.prevText"></a>
      </li>
      <template v-for="(page, index) in pages.array">
        <li v-if="page == '...'" class="page-item disabled" :key="index">
          <a class="page-link"><strong>{{ page }}</strong></a>
        </li>
        <li v-else class="page-item" :class="{ 'active' : page == pages.options.current }" :key="index">
          <a class="page-link" @click="$emit('change', page)">
            <strong>{{ page }}</strong>
          </a>
        </li>
      </template>
      <li v-if="pages.options.current !== pages.options.totalPages && pages.options.totalResults > 0" class="page-item">
        <a class="page-link" @click="$emit('change', pages.options.current + 1)" v-html="pages.options.nextText"></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PagingInput',
  props: {
    options: { type: Object }
  },
  computed: {
    pages () {
      let options = {
        centered: false,
        current: 1,
        totalResults: 10,
        totalPages: 1,
        padding: 1,
        paddingText: '...',
        nextText: '<span class="fa fa-chevron-right fa-fw"></span>',
        prevText: '<span class="fa fa-chevron-left fa-fw"></span>',
        limit: 10,
        ...this.options
      }
      let array = []
      options.totalPages = Math.ceil(options.totalResults / options.limit)
      if (options.totalPages < 7) {
        for (let i = 1; i <= options.totalPages; i++) {
          array.push(i)
        }
      } else {
        let range = []
        for (let i = 1; i <= options.totalPages; i++) {
          if (i === 1 || i === options.totalPages || i >= options.current - 1 && i <= options.current + 1) {
            range.push(i)
          }
        }
        let j
        for (let i of range) {
          if (j) {
            if (i - j === 2) {
              array.push(j + 1)
            } else if (i - j !== 1) {
              array.push('...')
            }
          }
          array.push(i)
          j = i
        }
      }
      return { array, options }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PagingInput.vue